// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3r8RX","content":"LoadingAlert_content__2_3Qy"};